import { render, staticRenderFns } from "./ChallengeRow.vue?vue&type=template&id=23add056&scoped=true&"
import script from "./ChallengeRow.vue?vue&type=script&lang=js&"
export * from "./ChallengeRow.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeRow.vue?vue&type=style&index=0&id=23add056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23add056",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VRow})
